import config from './config';
import queryParam from './queryParam';

const inspect = !!queryParam('inspect');
const logs = !!queryParam('logs');
const env = queryParam('env') || 'staging';
const language = (queryParam('lang') || 'en').replace('_', '-');
const theme = queryParam('theme') || '';
const outcomeIndicator = !queryParam('disableOutcomeIndicator');
const logo = queryParam('logo');
const cpvUuid = queryParam('cpv') || '6f70074d-28f5-4941-89ba-2199d794cb9f'; // Prva firma
const companyUuid = queryParam('companyUuid') || 'b99752b3-443c-4c80-b559-945a95c4b805'; // Prva firma
const paramTv = queryParam('tv');
const template = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

export default {
  inspect,
  logs,
  env,
  language,
  theme,
  outcomeIndicator,
  template,
  company: {
    cpv: cpvUuid,
    uuid: companyUuid,
  },
  layout: {
    id: config.TV.id[paramTv ? paramTv.split('-')[0] : 5],
    type: config.TV.type[paramTv ? paramTv.split('-')[1] : 5],
  },
  logoSource: {
    cms: logo
      ? `${config.API.cms[env]}/${config.API.gravity.applicationKey[companyUuid] || logo}/${logo}_logo-images/live-visualization_logo.png` : '',
    assets: logo
      ? `${config.assetPath}/${logo}/media/live-betting-display/${env === 'production' ? 'master' : env}/logo.png` : '',
  },
  socket: {
    deliveryPlatform: config.socket.deliveryPlatform,
    serviceAliveTimeout: config.socket.serviceAliveTimeout,
    subscribeOptions: {
      fullBetMeta: true,
      excludeBetGroups: true,
      betsCacheKey: '',
    },
  },
};
